export const dropDownAction = (id) => {
    return{
        type: 'changeDropDownOpen',
        id: id
    }
}